import { MonthlyPrayerTimes } from '../types';

export const octoberPrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "04:34",
    shoruk: "06:46",
    dhuhr: "12:43",
    asr: "15:34",
    maghrib: "18:29",
    isha: "20:24"
  },
  2: {
    fajr: "04:37",
    shoruk: "06:48",
    dhuhr: "12:42",
    asr: "15:32",
    maghrib: "18:27",
    isha: "20:21"
  },
  3: {
    fajr: "04:40",
    shoruk: "06:50",
    dhuhr: "12:42",
    asr: "15:30",
    maghrib: "18:24",
    isha: "20:17"
  },
  4: {
    fajr: "04:42",
    shoruk: "06:53",
    dhuhr: "12:42",
    asr: "15:28",
    maghrib: "18:21",
    isha: "20:14"
  },
  5: {
    fajr: "04:45",
    shoruk: "06:55",
    dhuhr: "12:41",
    asr: "15:25",
    maghrib: "18:18",
    isha: "20:11"
  },
  6: {
    fajr: "04:47",
    shoruk: "06:57",
    dhuhr: "12:41",
    asr: "15:23",
    maghrib: "18:15",
    isha: "20:08"
  },
  7: {
    fajr: "04:50",
    shoruk: "07:00",
    dhuhr: "12:41",
    asr: "15:21",
    maghrib: "18:12",
    isha: "20:05"
  },
  8: {
    fajr: "04:52",
    shoruk: "07:02",
    dhuhr: "12:40",
    asr: "15:19",
    maghrib: "18:09",
    isha: "20:02"
  },
  9: {
    fajr: "04:55",
    shoruk: "07:04",
    dhuhr: "12:40",
    asr: "15:17",
    maghrib: "18:06",
    isha: "19:59"
  },
  10: {
    fajr: "04:57",
    shoruk: "07:07",
    dhuhr: "12:40",
    asr: "15:15",
    maghrib: "18:03",
    isha: "19:56"
  },
  11: {
    fajr: "05:00",
    shoruk: "07:09",
    dhuhr: "12:40",
    asr: "15:12",
    maghrib: "18:00",
    isha: "19:53"
  },
  12: {
    fajr: "05:02",
    shoruk: "07:11",
    dhuhr: "12:39",
    asr: "15:10",
    maghrib: "17:57",
    isha: "19:50"
  },
  13: {
    fajr: "05:05",
    shoruk: "07:14",
    dhuhr: "12:39",
    asr: "15:08",
    maghrib: "17:55",
    isha: "19:48"
  },
  14: {
    fajr: "05:07",
    shoruk: "07:16",
    dhuhr: "12:39",
    asr: "15:06",
    maghrib: "17:52",
    isha: "19:45"
  },
  15: {
    fajr: "05:09",
    shoruk: "07:18",
    dhuhr: "12:39",
    asr: "15:04",
    maghrib: "17:49",
    isha: "19:42"
  },
  16: {
    fajr: "05:12",
    shoruk: "07:21",
    dhuhr: "12:38",
    asr: "15:02",
    maghrib: "17:46",
    isha: "19:39"
  },
  17: {
    fajr: "05:14",
    shoruk: "07:23",
    dhuhr: "12:38",
    asr: "14:59",
    maghrib: "17:43",
    isha: "19:36"
  },
  18: {
    fajr: "05:16",
    shoruk: "07:26",
    dhuhr: "12:38",
    asr: "14:57",
    maghrib: "17:40",
    isha: "19:34"
  },
  19: {
    fajr: "05:19",
    shoruk: "07:28",
    dhuhr: "12:38",
    asr: "14:55",
    maghrib: "17:38",
    isha: "19:31"
  },
  20: {
    fajr: "05:21",
    shoruk: "07:31",
    dhuhr: "12:38",
    asr: "14:53",
    maghrib: "17:35",
    isha: "19:29"
  },
  21: {
    fajr: "05:23",
    shoruk: "07:33",
    dhuhr: "12:38",
    asr: "14:51",
    maghrib: "17:32",
    isha: "19:26"
  },
  22: {
    fajr: "05:26",
    shoruk: "07:35",
    dhuhr: "12:37",
    asr: "14:49",
    maghrib: "17:29",
    isha: "19:23"
  },
  23: {
    fajr: "05:28",
    shoruk: "07:38",
    dhuhr: "12:37",
    asr: "14:47",
    maghrib: "17:27",
    isha: "19:21"
  },
  24: {
    fajr: "05:30",
    shoruk: "07:40",
    dhuhr: "12:37",
    asr: "14:45",
    maghrib: "17:24",
    isha: "19:18"
  },
  25: {
    fajr: "05:32",
    shoruk: "07:43",
    dhuhr: "12:37",
    asr: "14:43",
    maghrib: "17:21",
    isha: "19:16"
  },
  26: {
    fajr: "04:34",
    shoruk: "06:45",
    dhuhr: "11:37",
    asr: "13:41",
    maghrib: "16:19",
    isha: "18:14"
  },
  27: {
    fajr: "04:37",
    shoruk: "06:48",
    dhuhr: "11:37",
    asr: "13:39",
    maghrib: "16:16",
    isha: "18:11"
  },
  28: {
    fajr: "04:39",
    shoruk: "06:50",
    dhuhr: "11:37",
    asr: "13:37",
    maghrib: "16:13",
    isha: "18:09"
  },
  29: {
    fajr: "04:41",
    shoruk: "06:53",
    dhuhr: "11:37",
    asr: "13:35",
    maghrib: "16:11",
    isha: "18:07"
  },
  30: {
    fajr: "04:43",
    shoruk: "06:55",
    dhuhr: "11:37",
    asr: "13:33",
    maghrib: "16:08",
    isha: "18:04"
  },
  31: {
    fajr: "04:45",
    shoruk: "06:57",
    dhuhr: "11:36",
    asr: "13:31",
    maghrib: "16:05",
    isha: "18:02"
  }
};